import { useEffect, useLayoutEffect, useState } from "react";
import SvgWrappableText from "../../preview/SvgWrappableText";

interface BrochurePage1TextProps {
  text: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export const BrochurePage1Text: React.FC<BrochurePage1TextProps> = ({
  text, x, y, width, height
}) => {
  const [mainTextHeight, setMainTextHeight] = useState(0);
  const [fontSize, setFontSize] = useState(100);
  const [recursion, setRecursion] = useState(0);

  const top = y + (height - mainTextHeight) * 0.5;

  const handleTextLayout = (h, _boxes) => {
    setMainTextHeight(h);
  }

  useLayoutEffect(() => {
    setRecursion(0);
    setFontSize(100);
  }, [text, width, height]);

  useEffect(() => {
    if (recursion >= 25) {
      return;
    }
    if (mainTextHeight > height) {
      setTimeout(() => {
        setFontSize(fontSize - 4);
        setRecursion(recursion + 1);  
      }, 5);
    }
  }, [mainTextHeight]);


  return (<g>
    {false && <rect 
      x={x}
      y={y}
      width={width}
      height={height}
      fill="none"
      stroke="black"
      strokeWidth={5}
    />}
    <SvgWrappableText
      text={text}
      color={"#000000"}
      x={x}
      top={top}
      width={width}
      fontSize={fontSize}
      fontWeight="400"
      textAnchor="left"
      onLayout={handleTextLayout}
    />
  </g>)
}
